module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'RolesLista'
      })
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "titulo"
  }, [_vm._v("Níveis de acesso")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'RolesLista'
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Editar nível de acesso")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "autocomplete": "off",
      "label": "Nome",
      "name": "name",
      "data-vv-as": "nome",
      "error-messages": _vm.errors.has('name') ? _vm.errors.first('name') : []
    },
    model: {
      value: (_vm.form.fields.name),
      callback: function($$v) {
        _vm.form.fields.name = $$v
      },
      expression: "form.fields.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('h6', [_vm._v("Acessos Gerais")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix mt-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Administração de usuários")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.permissions.acessos_gerais.administracao_usuarios),
      callback: function($$v) {
        _vm.form.fields.permissions.acessos_gerais.administracao_usuarios = $$v
      },
      expression: "form.fields.permissions.acessos_gerais.administracao_usuarios"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Administração de níveis de acesso")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.permissions.acessos_gerais.administracao_niveis_acesso),
      callback: function($$v) {
        _vm.form.fields.permissions.acessos_gerais.administracao_niveis_acesso = $$v
      },
      expression: "form.fields.permissions.acessos_gerais.administracao_niveis_acesso"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Visualizar relatórios")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.permissions.acessos_gerais.visualizar_relatorios),
      callback: function($$v) {
        _vm.form.fields.permissions.acessos_gerais.visualizar_relatorios = $$v
      },
      expression: "form.fields.permissions.acessos_gerais.visualizar_relatorios"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('h6', [_vm._v("Acesso a Imóveis")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix mt-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Acessar apenas imóveis com tarefas/vistorias atribuídas ao usuário (ex: fiscal)")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.limitado_tarefas),
      callback: function($$v) {
        _vm.form.fields.limitado_tarefas = $$v
      },
      expression: "form.fields.limitado_tarefas"
    }
  })], 1), _vm._v(" "), (!_vm.form.fields.limitado_tarefas) ? _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Acessar apenas imóveis de proprietários específicos")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.limitado_proprietario),
      callback: function($$v) {
        _vm.form.fields.limitado_proprietario = $$v
      },
      expression: "form.fields.limitado_proprietario"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.fields.limitado_proprietario) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "items": _vm.proprietarios,
      "label": "Limitado aos imóveis do(s) proprietário(s) selecionado(s)"
    },
    model: {
      value: (_vm.form.fields.limitado_proprietario_lista),
      callback: function($$v) {
        _vm.form.fields.limitado_proprietario_lista = $$v
      },
      expression: "form.fields.limitado_proprietario_lista"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "permissions-table-wrap"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("Categoria")]), _vm._v(" "), _vm._l((_vm.actions), function(action) {
    return _c('td', {
      key: action.id,
      staticClass: "text-xs-center"
    }, [_vm._v("\n                        " + _vm._s(action.name)), _c('br'), _vm._v(" "), _c('small', [_c('u', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.toggleAllAction(action.id)
        }
      }
    }, [_vm._v("Marcar todos")])])])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.categories), function(category) {
    return _c('tr', {
      key: category.id
    }, [_c('td', [_vm._v("\n                        " + _vm._s(category.name)), _c('br'), _vm._v(" "), _c('small', [_c('u', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.toggleAllCategory(category.id)
        }
      }
    }, [_vm._v("Marcar todos")])])]), _vm._v(" "), _vm._l((_vm.actions), function(action) {
      return _c('td', {
        key: action.id
      }, [_c('v-checkbox', {
        staticClass: "status_checkbox",
        attrs: {
          "color": "secondary",
          "hide-details": ""
        },
        model: {
          value: (_vm.form.fields.permissions[category.id][action.id]),
          callback: function($$v) {
            _vm.$set(_vm.form.fields.permissions[category.id], action.id, $$v)
          },
          expression: "form.fields.permissions[category.id][action.id]"
        }
      })], 1)
    })], 2)
  }))])])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-center mt-4 mb-2",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "offset-sm2": "",
      "md6": "",
      "offset-md3": ""
    }
  }, [_c('v-btn', {
    staticClass: "red red--text ma-0",
    attrs: {
      "outline": "",
      "block": "",
      "large": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openDialogApagar($event)
      }
    }
  }, [_vm._v("\n                Apagar\n              ")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "560"
    },
    model: {
      value: (_vm.dialogApagar),
      callback: function($$v) {
        _vm.dialogApagar = $$v
      },
      expression: "dialogApagar"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Apagar nível de acesso?")]), _vm._v(" "), _c('v-card-text', [_vm._v("Usuários vinculados a este nível perderão suas permissões granulares.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogApagar = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.apagarRole($event)
      }
    }
  }, [_vm._v("Apagar")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15f5b579"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Roles/RolesEditar.vue
// module id = 988
// module chunks = 1